import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FileDownloaderService,
  IFileDownloaderTick,
} from '../../services/file-downloader.service';
import * as moment from 'moment';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PatientFilesService } from 'src/app/shared/services';
import { IPatientArchivesQuery } from 'src/app/shared/interfaces';
import { EDownloadStatus } from '../../enums/download-status.enum';
import { HttpEventType } from '@angular/common/http';
import { NzProgressModule } from 'ng-zorro-antd/progress';

@UntilDestroy()
@Component({
  selector: 'app-file-downloader-row',
  standalone: true,
  imports: [CommonModule, NzIconModule, NzProgressModule],
  templateUrl: './file-downloader-row.component.html',
  styleUrls: ['./file-downloader-row.component.scss'],
})
export class FileDownloaderRowComponent implements OnInit {
  @Input({ required: true }) public data!: IFileDownloaderTick;
  public status: EDownloadStatus = EDownloadStatus.PREPARING;
  public statuses = EDownloadStatus;
  public progress = 0;

  get name(): string {
    return this.data.meta.name || `Archive_${moment().format('DD-MM-YYYY')}`;
  }

  private readonly _fileDownloaderService = inject(FileDownloaderService);
  private readonly _patientFilesService = inject(PatientFilesService);

  ngOnInit(): void {
    this._download(this.data?.query);
  }

  private _download(body: IPatientArchivesQuery): void {
    this.status = EDownloadStatus.PREPARING;
    this._patientFilesService
      .getPatientArchives(body, this.name)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: event => {
          if (event.type === HttpEventType.DownloadProgress) {
            this.progress = Math.round(
              (100 * event.loaded) / (event.total || 1)
            );
            this.status = EDownloadStatus.DOWNLOADING;
          } else if (event.type === HttpEventType.Response) {
            this.progress = 100;
            this.status = EDownloadStatus.SUCCESS;
          }
        },
        error: () => {
          this.status = EDownloadStatus.ERROR;
        },
      });
  }
}
